import React, { useContext, useEffect, useState } from 'react';
// import { IoMdRefreshCircle } from 'react-icons/io';
import { Context } from '../Context/Context';

// import Search from '../Components/Images/search-lg.svg';
// import Bell from '../Components/Images/bell-01.svg';
import Add from '../Components/Images/AddBtn.svg';
import refresh from '../Components/Images/refresh.svg'
import warn from '../Components/Images/Warn.svg'
import close from '../Components/Images/close.png'

import BeneficiaryBar from './BeneficiaryBar';
import BeneficiaryInfo from './BeneficiaryInfo';
import ViewDetailsBar from './ViewDetailsBar';
import DeleteProfile from './DeleteProfile';
import { useLocation, useNavigate } from 'react-router-dom';
// import EditProfileBar from './EditProfileBar';
// import ManuelBeneficiary from './ManuelBeneficiary';
// import DeleteBenModal from './DeleteBenModal';

const AddBeneficiary = ({ UserBeneficiaryDetails, verified, getBeneficiaries, NumberOfBeneficiaryAcct, loadingBen }) => {
    const {
        handleBeneficiaryBar,
        beneficiaryBar,
        viewDetails,
        handleViewDetails,
        profileEdit,
        handleProfileEdit,
        sendBarFromBeneficiary,
        handleSendBarFromBeneficiary,
        method,
        beneficiaryAcct,
        formDatas,
        cryptoformData,
    } = useContext(Context);
    const location = useLocation()
    const navigate = useNavigate()


    const isVerified = () => {
        if (!verified) {
            navigate('/dashboard', {
                replace: true,
                state: {
                    error: 'You need to fill in your KYC data to continue',
                    from: location.pathname,
                },
            });
            return;
        }

        handleBeneficiaryBar();
    };

    const [deleteBenBar, setDeleteBenBar] = useState(false);
    const [deleteErrorBar, setDeleteErrorBar] = useState(false);
    const [openBenModal, setOpenBenModal] = useState(false);
    const [errorModal, setErrorModal] = useState({ open: false, message: '' });
    const [openSendBar, setOpenSendBar] = useState(false);
    const [SendErrorBar, setSendErrorBar] = useState({ state: false, message: '' });

    useEffect(() => {
        if (openBenModal) {
            setTimeout(() => {
                setOpenBenModal(false)
            }, 4200);
        }
        if (errorModal) {
            setTimeout(() => {
                setErrorModal({ open: false, message: '' })
            }, 5200);
        }
        if (deleteBenBar) {
            setTimeout(() => {
                setDeleteBenBar(false)
            }, 4200);
        }
        if (deleteErrorBar) {
            setTimeout(() => {
                setDeleteErrorBar(false)
            }, 5200);
        }
        if (openSendBar) {
            setTimeout(() => {
                setOpenSendBar(false)
            }, 4200);
        }
        if (SendErrorBar) {
            setTimeout(() => {
                setSendErrorBar({ state: false, message: '' })
            }, 5200);
        }
    }, [openBenModal, errorModal, deleteBenBar, deleteErrorBar, openSendBar, SendErrorBar])

    return (
        <div className='relative'>
            <div
                className={`w-full top-0 h-[500%] text-[#1D1C1F] absolute z-30 ${profileEdit || beneficiaryBar || viewDetails || sendBarFromBeneficiary ? 'bg-black/10' : 'hidden'
                    }`}
                onClick={
                    profileEdit
                        ? handleProfileEdit
                        : beneficiaryBar
                            ? handleBeneficiaryBar
                            : viewDetails
                                ? handleViewDetails
                                : sendBarFromBeneficiary
                                    ? handleSendBarFromBeneficiary
                                    : null
                }
            ></div>

            <div className="md:p-10 py-10 px-4">
                <div className='flex justify-between items-center mb-2 sp:mb-0'>
                    <div className="flex items-center gap-2">
                        <p className="text-[28px] font-semibold">Beneficiaries</p>
                    </div>
                    <div className="flex md:items-center items-start gap-9">
                        <img
                            src={refresh}
                            alt=""
                            onClick={getBeneficiaries}
                            className='cursor-pointer'
                        />
                        {/* <img className="lg:block hidden cursor-pointer" src={Search} alt="" />
                        <img className="lg:block hidden cursor-pointer" src={Bell} alt="" /> */}
                        <img className="w-10 cursor-pointer" onClick={handleBeneficiaryBar} src={Add} alt="" />
                    </div>
                </div>
                <p className="text-[16px] font-normal pr-10 text-[#525154]">
                    View and manage your beneficiaries here.
                </p>
            </div>

            {loadingBen ? (
                <div className="flex justify-center items-center h-[20vh]">
                    <p className="text-lg font-medium text-[#531CB3]">Loading beneficiaries...</p>
                </div>
            ) : NumberOfBeneficiaryAcct > 0 ? (
                <div className='h-screen'>
                    <BeneficiaryInfo UserBeneficiaryDetails={UserBeneficiaryDetails} />
                    <ViewDetailsBar setSendErrorBar={setSendErrorBar} setOpenSendBar={setOpenSendBar} />
                    {/* <EditProfileBar /> */}
                    {/* <ManuelBeneficiary /> */}
                    <DeleteProfile
                        setDeleteBenBar={setDeleteBenBar}
                        setDeleteErrorBar={setDeleteErrorBar}
                    />
                </div>
            ) : (
                <div className="flex flex-col items-center gap-9 bg-[#F9F7FC] lg:mx-10 mx-4 px-2 py-16 rounded-md border-2 border-black/50 border-dashed">
                    <div className="max-w-[500px]">
                        <p className="text-center font-medium text-[20px]">Manage your beneficiaries</p>
                        <p className="text-center text-[14px] font-normal text-[#525154] mt-1">
                            Manage your beneficiaries in one place. Save and organize their details to enable
                            seamless payments and keep track of your transfer history with ease.
                        </p>
                    </div>
                    <button
                        className="bg-white border-[1.4px] text-[14px] font-medium text-[#525154] border-black/10 text-black/70 p-3 rounded-lg"
                        onClick={isVerified}
                    >
                        Add your first beneficiary
                    </button>
                </div>
            )}

            <BeneficiaryBar errorModal={errorModal} setErrorModal={setErrorModal} openBenModal={openBenModal} setOpenBenModal={setOpenBenModal} />
            {/* <DeleteBenModal
                deleteBenBar={deleteBenBar}
                setDeleteBenBar={setDeleteBenBar}
                deleteErrorBar={deleteErrorBar}
                setDeleteErrorBar={setDeleteErrorBar}
            /> */}

            {openBenModal && (
                <div className='absolute md:top-24 z-50 top-10 sm:right-10 right-2 flex items-center  justify-between p-4 rounded-lg bg-[#1CB353] text-[#F9F7FC]'>
                    <div className='flex gap-2 items-start'>
                        <img className='mt-1' src={warn} alt="" />
                        <div>
                            <p className='text-[14px] text-[#F9F7FC] font-medium'>Account added.</p>
                            <p className='text-[14px] text-[#CFF9DE] font-normal'>You've successfully added an account</p>
                        </div>
                        <img
                            onClick={() => setOpenBenModal(false)}
                            className='size-[10px] cursor-pointer'
                            src={close}
                            alt=""
                        />
                    </div>
                </div>
            )}

            {errorModal.open && (
                <div className='absolute md:top-24 z-50 top-10 sm:right-10 right-2 flex items-center  justify-between p-4 rounded-lg bg-[#EF4444] text-[#F9F7FC]'>
                    <div className='flex gap-2 items-start'>
                        <img className='mt-1' src={warn} alt="" />
                        <div>
                            <p className='text-[14px] text-[#F9F7FC] font-medium'>Failed to add account.</p>
                            <p className='text-[14px] text-[#CFF9DE] font-normal'>{errorModal.message}</p>
                        </div>
                        <img
                            onClick={() => setErrorModal({ open: false, message: '' })}
                            className='size-[10px] cursor-pointer'
                            src={close}
                            alt=""
                        />
                    </div>
                </div>
            )}

            {deleteBenBar && (
                <div className='absolute md:top-24 z-50 top-10 sm:right-10 right-2 flex items-center  justify-between p-4 rounded-lg bg-[#1CB353] text-[#F9F7FC]'>
                    <div className='flex gap-2 items-start'>
                        <img className='mt-1' src={warn} alt="" />
                        <div>
                            <p className='text-[14px] text-[#F9F7FC] font-medium'>Account deleted.</p>
                            <p className='text-[14px] text-[#CFF9DE] font-normal'>You've successfully deleted the account</p>
                        </div>
                        <img
                            onClick={() => setDeleteBenBar(false)}
                            className='size-[10px] cursor-pointer'
                            src={close}
                            alt=""
                        />
                    </div>
                </div>
            )}

            {deleteErrorBar && (
                <div className='absolute md:top-24 z-50 top-10 sm:right-10 right-2 flex items-center  justify-between p-4 rounded-lg bg-[#EF4444] text-[#F9F7FC]'>
                    <div className='flex gap-2 items-start'>
                        <img className='mt-1' src={warn} alt="" />
                        <div>
                            <p className='text-[14px] text-[#F9F7FC] font-medium'>Failed to delete account.</p>
                            <p className='text-[14px] text-[#CFF9DE] font-normal'>We couldn’t delete the account at the moment. Please try again later.</p>
                        </div>
                        <img
                            onClick={() => setDeleteErrorBar(false)}
                            className='size-[10px] cursor-pointer'
                            src={close}
                            alt=""
                        />
                    </div>
                </div>
            )}

            {openSendBar && (
                <div className='absolute md:top-24 z-50 top-10 sm:right-10 right-2 flex items-center  justify-between p-4 rounded-lg bg-[#1CB353] text-[#F9F7FC]'>
                    <div>
                        <div className='flex gap-2 items-start'>
                            <img className='mt-1' src={warn} alt="" />
                            <div>
                                <p className='text-[14px] text-[#F9F7FC] font-medium'>Money sent.</p>
                                {method === 'bank' ? (
                                    <p className='text-[14px] text-[#CFF9DE] font-normal'> <span className='font-medium'>${formDatas.amount}</span> is on it's way to <span className='font-medium'>{beneficiaryAcct?.full_name}</span></p>
                                ) : (
                                    <p className='text-[14px] text-[#CFF9DE] font-normal'> <span className='font-medium'>${cryptoformData.amount}</span> is on it's way to <span className='font-medium'>{beneficiaryAcct?.full_name}</span></p>
                                )}
                            </div>
                            <img
                                onClick={() => setOpenSendBar(false)}
                                className='size-[10px] cursor-pointer'
                                src={close}
                                alt=""
                            />
                        </div>
                    </div>

                </div>
            )}

            {SendErrorBar.state && (
                <div className='absolute md:top-24 z-50 top-10 sm:right-10 right-2 flex items-center justify-between p-4 rounded-lg bg-[#EF4444] text-[#F9F7FC]'>
                    <div className='flex justify-between'>
                        <div className='flex gap-2 items-start'>
                            <img className='mt-1' src={warn} alt="" />
                            <div>
                                <p className='text-[14px] text-[#F9F7FC] font-medium'>Failed!</p>
                                <p className='text-[14px] text-[#CFF9DE] font-normal'>Failed to send money to {beneficiaryAcct?.full_name}!.</p>
                                <p className='text-[14px] text-[#CFF9DE] font-normal'>{SendErrorBar.message}</p>
                            </div>
                        </div>
                        <img
                            onClick={() => setSendErrorBar({ state: false, message: '' })}
                            className='size-[10px] cursor-pointer'
                            src={close}
                            alt=""
                        />
                    </div>
                </div>
            )}

        </div>
    );
};

export default AddBeneficiary;
